import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';

import { DialogFooter, DialogActionButton } from 'components/Dialog';

const PREFIX = 'SessionNoticeDialog';

const classes = {
  root: `${PREFIX}-root`,
  title: `${PREFIX}-title`,
  text: `${PREFIX}-text`,
  actions: `${PREFIX}-actions`,
  button: `${PREFIX}-button`,
};

const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`&.${classes.root}`]: {},

  [`& .${classes.title}`]: {
    display: 'block',
    color: theme.colorTokens.onSurfaceTextHeadline,
    marginBottom: 0,
    fontWeight: 700,
    fontSize: '1.2rem',
  },

  [`& .${classes.text}`]: {
    color: theme.colorTokens.onSurfaceTextTitle,
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'center',
  },

  [`& .${classes.button}`]: {
    minWidth: '120px',
    borderRadius: '40px',
    fontWeight: 600,
  },
}));

export default function SessionNoticeDialog() {
  const [openDialog, setOpenDialog] = useState(true);

  const handleClose = () => {
    setOpenDialog(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <StyledDialog maxWidth="md" open={openDialog} onClose={handleClose} className={classes.root}>
      <DialogTitle>
        <strong className={classes.title}>Your session will end soon!</strong>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.text}>Please make your requests within the session time before it runs out.</Typography>
      </DialogContent>
      <DialogFooter className={classes.actions} style={{ justifyContent: 'flex-end' }}>
        <DialogActionButton onClick={handleClose} variant="contained" color="primary" disableElevation>
          Got It
        </DialogActionButton>
      </DialogFooter>
    </StyledDialog>
  );
}
